import { toObjectMap } from "@@/utilities/dictionary";

const packageStatus = [
    "CREATED",
    "WAITING_FOR_PICKUP",
    "ONROUTE",
    "DELIVERED",
    "LOST",
] as const;
type packageStatus = (typeof packageStatus)[number];
const packageStatusMap = toObjectMap<packageStatus>([...packageStatus]);

export { packageStatusMap, packageStatus };
